import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Autocomplete, TextField, Thumbnail } from '@shopify/polaris';

import axiosRails from '@utils/axios';
import debounce from 'lodash/debounce';

import { Set } from 'immutable';

// import Thumbnail from './ImageThumb';

const availableFilters = [
  "id", "sku", "barcode", "title", "vendor", "tag"
]

const propTypes = {
  onSelection: PropTypes.func.isRequired,
  queryURL: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  sellerUserId: PropTypes.number,
}

const defaultProps = {
  label: "",
  placeholder: "Busqueda..."
}

class ProductDropdownSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      searchValue: "",
      foundItems: [],
      selectedFilters: Set(["sku", "barcode"]),
      selectedProduct: [],
    }
    this.queryProducts = debounce(this.queryProducts, 1000);
  }

  render() {
    let { placeholder, value } = this.props;
    let { loading, selectedProduct, foundItems, selectedFilters } = this.state;
    // debugger;
    return (
      <div>
        <Autocomplete
          options={foundItems}
          selected={selectedProduct}
          onSelect={this.handleDropdownSelection}
          loading={loading}
          textField={
            <Autocomplete.TextField
              onChange={this.handleSearchChange}
              value={this.state.searchValue}
              label={this.props.label}
              placeholder={ placeholder }
            />
          }
        />
      </div>
    )
  }


  handleSearchChange = (newValue) => {
    this.setState({ searchValue: newValue }); // Input value.
    this.queryProducts(); // Will be called after N seconds if not called again. Defined on constructor()
  }

  // Return the selected item from the current options filtered.
  // Return data from dropdown and the item.record as it
  handleDropdownSelection = (selectedItem) => {
    this.queryProducts.cancel(); // Keep last query data and options.
    // let { options, value } = data;
    let { foundItems } = this.state

    let itemInfo = foundItems.find((item) => {
      return item.value == selectedItem[0]; // ID
    });

    this.setState({ selectedProduct: selectedItem });
    
    // console.log("handleDropdownSelection selected", selectedItem);
    this.props.onSelection(selectedItem, itemInfo)
  }

  queryProducts = async () => {

    const { searchValue, selectedFilters } = this.state;
    const { queryURL, sellerUserId } = this.props;

    // "" empty string  WOULD DO A expensive * query
    if (searchValue != "") {
      await this.setState({ loading: true }); // Do not allow another request?.
      try {
        let response = await axiosRails.post(queryURL, {
          query: searchValue,
          query_type: "products",
          filters: selectedFilters,
          id: sellerUserId,
        })

        let mappedProducts = response.data.products.map( (variant) => ({
          media: <Thumbnail  source={variant.image_url} />,
          label: variant.display_name, 
          value: String(variant.id), 
          record: variant,
        }));

        this.setState({ foundItems: mappedProducts, loading: false });
        // { value: x, label: mmm }
      } catch (error) {
        console.warn(error); // TODO Remove this and put a simple error handler
        this.setState({ loading: false });
      }
    }
  }

  // toggleFilterType = (filterName) => {
  //   const { selectedFilters } = this.state;
  //   let newFilters = selectedFilters.has(filterName) ? selectedFilters.delete(filterName) : selectedFilters.add(filterName);
  //   this.setState({
  //     selectedFilters: newFilters,
  //   })
  // }

}

ProductDropdownSearch.propTypes = propTypes;

ProductDropdownSearch.defaultProps = defaultProps;

export default ProductDropdownSearch;